import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Home } from './Home';
import { About } from './About';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Portfoli } from './Porfoli'
import { Contact_main } from './Contact_main';
import { Packages } from './Packages';
import { Main_logo } from './Main_logo';
import { Review } from './Review'
import { Website } from './Website'
import { Nft_design } from './Nft_design'
import { Animation_design } from './Animation_design'
import { Branding_design } from './Branding_design';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0,0);
  }, [pathname]

  )
  return (
    <>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/About" element={<About/>}/>
      <Route path="/Portfoli" element={<Portfoli/>}/>
      <Route path="/Contact_main" element={<Contact_main/>}/>
      <Route path="/Packages" element={<Packages/>}/>
      <Route path="/Main_logo" element={<Main_logo/>}/>
      <Route path="/Review" element={<Review/>}/>
      <Route path="/Website" element={<Website/>}/>
      <Route path="/Nft_design" element={<Nft_design/>}/>
      <Route path="/Animation_design" element={<Animation_design/>}/>
      <Route path="/Branding_design" element={<Branding_design/>}/>
    </Routes>
    </>
    )
}

export default App;
